import type { SlotGameStore, BaseComponentConfig } from "@gamzix/slot_core";

enum ModeTypes {
    buy = "buy",
    hotBet = "hotBet",
    choiceType = "choiceType",
}

class BuyFeatureComponent extends SlotGame.src.component.BaseComponent {
    static events = {
        BUY_FEATURE_POPUP_CHANGE_STATUS:
            "BUY_FEATURE.BUY_FEATURE_POPUP_CHANGE_STATUS",
    };

    protected isBuyFreeSpinsPopup: boolean = false;

    store = <SlotGameStore>game.store;

    public hotBetMultiplier = 1;
    protected _realBet: number = -1;

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isBuyFreeSpinsPopup: () => this.isBuyFreeSpinsPopup,
            isHotBetActive: () => {
                const { mode } = this.store.getServerMode(ModeTypes.hotBet);

                return mode;
            },
            isShowButtonBuy: () => {
                return (
                    this.valueTotalBet > 0 &&
                    !this.isBonusSpinsGame() &&
                    !this.isFreeSpinsGame() &&
                    !this.store.promo.isPrizeState()
                );
            },
            isEnableButtonBuy: () => {
                return (
                    this.valueTotalBet > 0 &&
                    !this.isBonusSpinsGame() &&
                    !this.isFreeSpinsGame() &&
                    !this.store.promo.isPrizeState() &&
                    !this.store.autoplay.isActive
                );
            },
            isOnButtonNext: () =>
                !(
                    this.store.gameData.bet ===
                    this.store.gameRules.bets[
                        this.store.gameRules.bets.length - 1
                    ] *
                        this.hotBetMultiplier
                ),
            isOnButtonPrev: () =>
                !(
                    this.store.gameData.bet ===
                    this.store.gameRules.bets[0] * this.hotBetMultiplier
                ),
            isEnoughMoneyForBuy: () =>
                this.store.balance >=
                this.store.gameData.baseBet * this.valueTotalBet,
        };

        this.text_checkers = {
            ...super.getTextCheckers(),

            GET_VALUE_TOTAL_BET: () => {
                return this.store.toFormatMoney(
                    (this.store.gameData.bet / this.hotBetMultiplier) *
                        this.valueTotalBet
                );
            },

            GET_CURRENT_BET: () =>
                this.store.toFormatMoney(this.store.gameData.bet),
        };
    }

    onGameReady() {
        super.onGameReady();

        this.changeBuyFeatureTitle();
    }

    changeBuyFeatureTitle() {
        if (this.options.config.buyFeatureConfig) {
            const titleTextureName =
                this.options.config.buyFeatureConfig.titleTextureName ||
                "buy_feature_title_fs";
            const buyFeatureTitle = game.tree.findByName("buy_feature_title");

            buyFeatureTitle.options.texture = `${titleTextureName}`;
            buyFeatureTitle.updateViewOptions();
        }
    }

    changeHotBetMultiplier() {
        const { mode } = this.store.getServerMode(ModeTypes.hotBet);

        if (mode) this.hotBetMultiplier = mode.multiplier;
        else this.hotBetMultiplier = 1;
    }

    get valueTotalBet(): number {
        return this.store.gameRules.getMode(ModeTypes.buy)?.price || 0;
    }

    onPopup() {
        this.isBuyFreeSpinsPopup = true;
        game.emit(BuyFeatureComponent.events.BUY_FEATURE_POPUP_CHANGE_STATUS, {
            status: this.isBuyFreeSpinsPopup,
        });
        this.onChangeOrientation();
        game.keybord.lock();
    }

    offPopup() {
        this.isBuyFreeSpinsPopup = false;
        game.emit(BuyFeatureComponent.events.BUY_FEATURE_POPUP_CHANGE_STATUS, {
            status: this.isBuyFreeSpinsPopup,
        });
        this.onChangeOrientation();
        game.keybord.unLock();
    }

    onBuyClick() {
        this.store.applyServerMode(this.store.gameRules.getMode(ModeTypes.buy));
        this.offPopup();
        this._realBet =
            (this.store.gameData.bet / this.hotBetMultiplier) *
            this.valueTotalBet;
        //@ts-ignore
        game.component.reelset.isSkipped = true;
        game.fsm.abortCurrentPhases();
    }

    nextValueBetPerSpin() {
        this.store.increaseBet();
        //@ts-ignore
        this.view.forceViewUpdate();
    }

    prevValueBetPerSpin() {
        this.store.decreaseBet();
        //@ts-ignore
        this.view.forceViewUpdate();
    }

    isFreeSpinsGame() {
        return (
            (this.store.gameData.freeSpinsGame.hasSpins() &&
                !this.store.gameData.freeSpinsGame.isStarted()) ||
            this.store.gameData.freeSpinsGame.isFinished()
        );
    }

    isBonusSpinsGame() {
        return (
            (this.store.gameData.bonusGame.hasSpins() &&
                !this.store.gameData.bonusGame.isStarted()) ||
            this.store.gameData.bonusGame.isFinished()
        );
    }

    get realBet(): number {
        return this._realBet;
    }
}

export { BuyFeatureComponent };

//@ts-ignore
Game.src.component.BuyFeatureComponent = BuyFeatureComponent;
